import '../assets/fonts/css/i3Theme.css'
type TPaletteMode = 'light' | 'dark'

// Focus border color based on theme mode
const focusBorderColor = (mode: TPaletteMode) => (mode === 'light' ? '#000' : '#fff')

const mode: TPaletteMode = 'light'

const themeObj = {
  palette: {
    mode,

    primary: {
      //primary accent color on light backgrounds (Russian Green color)
      main: '#41683b',
    },
    secondary: {
      //secondary accent color on light backgrounds (fern Green color)
      //prefer it for smaller text in light background
      main: '#4c7b46',
    },
    text: {
      // primary text color(jet color)   on light background
      primary: '#2e312f',
      //secondary text color(dave grey color)   on light background
      secondary: '#545654',
    },
  },
  typography: {
    fontFamily:
      'NunitoSans Bold, NunitoSans Italic, NunitoSans Regular, Playfair Display Bold, Raleway Bold, Nunito Bold',
    h5: { fontFamily: 'Nunito Bold' },
    // h5: { fontFamily: 'Playfair Display Bold' },
    h6: { fontFamily: 'Nunito Bold' },
    // h6: { fontFamily: 'Playfair Display Bold' },
    body1: { fontFamily: 'NunitoSans Regular' },
    body2: { fontFamily: 'NunitoSans Bold' },
    subtitle1: { fontFamily: 'Nunito Bold' },
    // subtitle1: { fontFamily: 'Raleway Bold' },
    caption: { fontFamily: 'NunitoSans Italic' },
    body1xs: {
      fontFamily: 'NunitoSans Regular',
      fontSize: '0.75rem',
      letterSpacing: '0.01071em',
      lineHeight: 1.36,
    },
    body1small: {
      fontFamily: 'NunitoSans Regular',
      fontSize: '0.875rem',
      letterSpacing: '0.01204em',
      lineHeight: 1.43,
    },

    body2small: {
      fontFamily: 'NunitoSans Bold',
      fontSize: '0.8rem',
      letterSpacing: '0.01204em',
      lineHeight: 1.39,
    },
  },
  custom: {
    //primary text color on dark backgrounds
    darkAccentPrimaryColor: '#faf4f2',
    //secondary text color on dark backgrounds
    darkAccentSecondaryColor: '#939994',
    //primary accent color on dark backgrounds
    darkBackgroundPrimaryAccentColor: '#9cdd93',
    //primary accent color on dark backgrounds
    darkBackgroundSecondaryAccentColor: '#efc8c3',
    // red primary accent color on light backgrounds
    redSecondaryAccentColor: '#ca786e',
    // red accent color on light background color
    redTertiaryAccentColor: '#ad584e',
    //smoke white color
    smokeWhiteBackgroundColor: '#F5F5F5',
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: 'none',
            border: `2px solid ${focusBorderColor(mode)}`,
            borderRadius: '4px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: 'none',
            border: `2px solid ${focusBorderColor(mode)}`,
            borderRadius: '4px',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: 'none',
            border: `2px solid ${focusBorderColor(mode)}`,
            borderRadius: '4px',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          '&:focus-visible': {
            outline: 'none',
            border: `2px solid ${focusBorderColor(mode)}`,
            borderRadius: '4px',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#000', // Default black border
            },
            '&:hover fieldset': {
              borderColor: '#000', // Maintain black border on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#000', // Maintain black border when focused
            },
            // Red border when there's an error (touched and no value)
            '&.Mui-error fieldset': {
              borderColor: '#ca786e', // Red border for error state
            },
            '&.Mui-error:hover fieldset': {
              borderColor: '#ca786e', // Maintain red border on hover when error
            },
            '&.Mui-error.Mui-focused fieldset': {
              borderColor: '#ca786e', // Maintain red border when focused and error
            },
          },
          // Green border when value is selected (has value-selected class)
          '&.value-selected .MuiOutlinedInput-root fieldset': {
            borderColor: '#41683b', // Green border for selected state
          },
          '&.value-selected .MuiOutlinedInput-root:hover fieldset': {
            borderColor: '#41683b', // Maintain green border on hover when selected
          },
          '&.value-selected .MuiOutlinedInput-root.Mui-focused fieldset': {
            borderColor: '#41683b', // Maintain green border when focused and selected
          },
          // Green label when value is selected
          '&.value-selected .MuiOutlinedInput-root .MuiInputLabel-root': {
            color: '#41683b', // Green label for selected state
          },
          '&.value-selected .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root': {
            color: '#41683b', // Maintain green label when focused and selected
          },
          // Default label font size
          '& .MuiOutlinedInput-root .MuiInputLabel-root': {
            fontSize: '1.1rem', // Label font size for all states
          },
          // Ensure label is 1.1rem when focused even if no value-selected class
          '& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root': {
            fontSize: '1.1rem',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#000', // Black border for text fields
            },
            '&:hover fieldset': {
              borderColor: '#000', // Maintain black border on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#000', // Maintain black border when focused
            },
          },
          // Make TextField labels 1.1rem when focused or in default state
          '& .MuiInputLabel-root': {
            fontSize: '1.1rem',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root': {
            fontSize: '1.1rem',
          },
        },
      },
    },
  },
}

export default themeObj

//usage of  theme custom settings
//1) using styled components (preferred)
//   const DarkButton = styled(Button)(({ theme }) => ({
//     color: theme.custom.darkAccentPrimaryColor.color,
//     backgroundColor:
//       theme.custom.darkBackgroundSecondaryAccentColor.backgroundColor,
//   }));
//2) Using sx props
//  <Button variant="contained"
// sx={{
// color:theme.custom.darkAccentPrimaryColor ,
// }}
// >
// new2
// </Button>
